import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { classMap as o } from '../../../../node_modules/lit-html/directives/class-map.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { StyleTypes } from './types.js';
import css_248z from './spacer.scss.js';

class Spacer extends s {
    constructor() {
        super(...arguments);
        this.styleType = StyleTypes.OFFWHITE;
        this.isFullWidth = false;
    }
    render() {
        const styleClass = `style-${this.styleType}`;
        return $ `<div class="spacer ${o({
            [styleClass]: true,
            fullWidth: this.isFullWidth,
        })}"></div>`;
    }
}
Spacer.styles = css_248z;
__decorate([
    e({ type: String })
], Spacer.prototype, "styleType", void 0);
__decorate([
    e({ type: Boolean })
], Spacer.prototype, "isFullWidth", void 0);
customElements.define('cvt-spacer', Spacer);

export { Spacer };
